import { Alert, AlertTitle } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

const BANNER_SX = { mb: 2 } satisfies SxProps<Theme>

// The off-switch is enforced on the server. This banner names the state, and the grid below
// disables the three controls the server refuses, so nothing there can be triggered at all.
// Delete stays live: the server keeps allowing it while tokens are off.
export default function TokensOffBanner() {
  return <Alert severity="warning" sx={BANNER_SX}>
    <AlertTitle>Personal access tokens are switched off for this account</AlertTitle>
    Existing tokens stay listed and can still be deleted. Create, copy and rotate are unavailable until tokens are switched back on in account settings.
  </Alert>
}
